// One page width and one side padding for the site header, the content pages
// and the footer, so their left edges line up at every width.
export const PAGE_MAX_WIDTH = 1200;
export const PAGE_GUTTER = { xs: 2, md: 5 } as const;

// sx for a centred page column: the width cap plus the shared side padding.
export const pageColumnSx = {
  width: '100%',
  maxWidth: PAGE_MAX_WIDTH,
  mx: 'auto',
  px: PAGE_GUTTER,
  boxSizing: 'border-box',
} as const;
